import { Color } from './TrendChart.component';

export const defaultTrendChartData: number[] = [
  7393.98, 7404.98, 7399.98, 7396.98, 7401.98, 7401.98, 7400.98, 7385.98, 7382.98, 7401.98, 7397.98, 7394.98, 7385.98,
  7364.98, 7420.98, 7424.98, 7435.98, 7418.98, 7411.98, 7402.98, 7402.98, 7402.98, 7402.98, 7393.98,
];

export const defaultTrendChartTheme: {
  green: Color;
  red: Color;
  gray: Color;
  middle?: Color;
} = {
  green: {
    line: 'rgba(68, 199, 144, 1)',
    start: '#44C790',
    middle: 'rgba(68, 199, 144, 0.2)',
    end: 'rgba(68, 199, 144, 0)',
  },
  red: {
    line: 'rgba(255, 98, 98, 1)',
    start: '#FF6262',
    middle: 'rgba(255, 98, 98, 0.2)',
    end: 'rgba(255, 98, 98, 0)',
  },
  gray: {
    line: '#828282',
    start: 'rgba(130, 130, 130, 1)',
    middle: 'rgba(130, 130, 130, 0.2)',
    end: 'rgba(130, 130, 130, 0)',
  },
};
